import { Component } from '@angular/core';
import { ActivatedRoute, Params, ParamMap } from "@angular/router";
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';
import { DashboardHttpUtil } from '../../dashboard.util';
import { StorageUtil } from '../../../../utils/storage.util';
import { CommunicationsStateService } from '../communications.state.service';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { AbstractFormComponent } from '../../../../core/abstract-form-component';
import { dialogValidationMessages, getDialogControlsConfig } from './dialog.communications.form';
import { CommunicationsHttpUtil } from '../communications.util';
import { AttachmentStateService } from '../../../common/attachment/attachment.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';

@Component({
  moduleId: module.id,
  templateUrl: 'dialog.communications.component.html',
  selector: 'bft-dialog-communications',
  providers: []
})

export class DialogCommunicationsComponent extends AbstractFormComponent {

  model = [];
  formModel = {
    text: '',
  };
  errorMessage: string;

  readonly QUEST_TYPE_OPEN = 'open';
  readonly QUEST_TYPE_CLOSE = 'close';
  questType = this.QUEST_TYPE_CLOSE;

  theme;
  chatType;
  number;

  isAttached: boolean = false;
  attachment = '';

  fileName;
  chatOpenedDialogStatus: boolean = true;

  constructor(private communicationsHttpService: CommunicationsHttpService,
              private communicationsStateService: CommunicationsStateService,
              private formBuilder: FormBuilder,
              private attachmentStateService: AttachmentStateService,
              private authUtil: AuthUtil) {
    super();

    // For add mobile class and hide chat list and show dialog
    this.communicationsStateService.handleSetMobileClass().subscribe(data => {
      this.setMobileClass(!data.dialogStatus);
    });

    this.communicationsStateService.handleSingleQuest().subscribe(data => {
      this.isAttached = false;
      this.attachment = '';
      this.errorMessage = '';
      this.form.reset();
      this.formErrors['text'] = '';
      this.getQuest(data.number);
      this.questType = data.questType;
      this.theme = data.theme;
      this.chatType = data.chatType;
      this.number = data.number;

      // For add mobile class and hide chat list and show dialog
      this.communicationsStateService.triggerSetMobileClass({dialogStatus: true});
    });
  }

  getQuest(number) {
    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    this.communicationsHttpService.getSingleChat(requestParams, number).subscribe(
      success => {
        if (success) {
          let data = success.json();
          if(this.authUtil.checkErrorResponse(data)) {
            this.model = data.response && data.response.items || [];
          }
        }
      },
      error => {
      },
      () => {
      });
  }

  buildForm(): FormGroup {
    return this.formBuilder.group(getDialogControlsConfig(this.formModel, this.formBuilder));
  }

  getValidationMessages(): {} {
    return dialogValidationMessages;
  }

  submit() {
    this.sendMessage();
  }

  sendMessage(action = 1) {
    delete this.errorMessage;

    let data = {
      securityToken: StorageUtil.getToken(),
      chatMessage: this.form.value.text,
      action: action,
      attachment: this.attachment,
    };

    let requestParams = CommunicationsHttpUtil.prepareParamsSendMessage(data);
    this.communicationsHttpService.sendMessageToChat(requestParams, this.number).subscribe(
      success => {
        if (success) {
          this.form.reset();
          this.isAttached = false;
          this.attachment = '';
          if(action) {
            this.getQuest(this.number);
          } else {
            this.questType = this.QUEST_TYPE_CLOSE;
            this.communicationsStateService.triggerReloadData({});
          }

          let data = success.json();
          this.authUtil.checkErrorResponse(data);
        }
      },
      error => {
        this.errorMessage = 'Произошла ошибка.';
      },
      () => {
      });
  }

  closeChat($event) {
    $event.preventDefault();
    this.sendMessage(0);
  }

  getMessageAttach($event, messageId) {
    $event.preventDefault();

    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    this.communicationsHttpService.getMessageAttach(requestParams, messageId)
      .map(res => {
        if(res.headers.get('content-disposition')) {
          this.fileName = res.headers.get('content-disposition').split('"')[1];
          return res.blob();
        }
      })
      .subscribe(
        blobContent => {
          if(blobContent) {
            saveAs(blobContent, this.fileName);
          } else {
            this.authUtil.redirect();
          }
        },
        error => {
          this.authUtil.redirect();
        },
        () => {
        });
  }

  triggerSetAttachment($event) {
    this.isAttached = !!$event.attachment;
    this.attachment = $event.attachment;
  }

  setMobileClass(flag) {
    this.chatOpenedDialogStatus = flag;
  }

  hideMobileDialogArea($event) {
    $event.preventDefault();

    // For add mobile class and hide chat list and show dialog
    this.communicationsStateService.triggerSetMobileClass({dialogStatus: false});
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/dialog-communications/dialog.communications.component.ts